import { lazy } from 'react';
import Loadable from '@/components/base-component/Loadable';

//============ Page Components ===============
const Dashboard = Loadable(lazy(() => import('@/pages/dashboard/dashboard')));
const Users = Loadable(lazy(() => import('@/pages/dashboard/admin-users')));
const LatexPurchase = Loadable(lazy(() => import('@/pages/dashboard/latex-purchase-order')));
const LatexDaily = Loadable(lazy(() => import('@/pages/dashboard/latex-daily-batch')));
const LatexPeriod = Loadable(lazy(() => import('@/pages/dashboard/latex-period')));
const LatexCustomerSummaryReport = Loadable(lazy(() => import('@/pages/dashboard/latex-report/customer-summary')));
const PurchaseSummaryAllSummaryReport = Loadable(lazy(() => import('@/pages/dashboard/latex-report/purchase-summary-all')));
const LatexProfitSummaryReport = Loadable(lazy(() => import('@/pages/dashboard/latex-report/profit-summary')));
const Latexpayment = Loadable(lazy(() => import('@/pages/dashboard/latex-payment')));
const Latexprice = Loadable(lazy(() => import('@/pages/dashboard/latex-price-setting')));
// ::: ลำดับชั้นของ Path จะต้องเรียงลำดับให้ตรงในรายการ allowUsers List
// ::: ที่อยู่ของรายการ allowAdmins List ==> /src/components/menu-items/admins
export const adminRoutes = [
  {
    path: 'dashboard', // ไม่ต้องมี "/"
    element: <Dashboard />
  },
  {
    path: 'users',
    element: <Users />
  },
  {
    path: 'latex-purchase-order',
    element: <LatexPurchase />
  },
  {
    path: 'latex-daily-batch',
    element: <LatexDaily />
  },
  {
    path: 'latex-period',
    element: <LatexPeriod />
  },
  {
    path: 'customer-summary',
    element: <LatexCustomerSummaryReport />
  },
  {
    path: 'purchase-summary-all',
    element: <PurchaseSummaryAllSummaryReport />
  },
  {
    path: 'profit-summary',
    element: <LatexProfitSummaryReport />
  },
  {
    path: 'latex-payment',
    element: <Latexpayment />
  },
  {
    path: 'latex-price-setting',
    element: <Latexprice />
  }
];
